module.exports = __webpack_public_path__ + "static/products-full-width-85357520b02403983a231bb940d46f8c.jpg";